import { DropDownListCSSStyleImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownlistcss';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';


export class ToneOptionDropDownListCSSStyleImpl extends DropDownListCSSStyleImpl
{
    getWrapperCSSStyle():object
    {
        return{
            listStyleType: "none",
            width: "100%",
            // height: "100%",
            display: "flex",
            flexFlow: "row wrap",
            paddingBottom:this.getContext().getUserContext().getLanguage() === LanguageConst.BURMESE && "10px",
            borderRadius:'25.5px',
            // boxShadow:' 0 3px 10px 0 rgba(0,0,0,0.25)'
            // border: '1px solid #EAECEF'
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecard/toneoptions/toneoptiondropdownlistcss.tsx